export const environment = {
    production: true,
    domain: 'hassaly.com',
    apiPrefix: 'api/v1',
    adminHost: 'hassaly.com/admin/',
};
